import { Route } from "@angular/router";
import { Platform } from "./models/platform";

export const WeldoenersPaths = {
  Approve: "goedkeuren",
  Statistics: "statistieken",
  Vacatures: "vacatures",
  Volunteers: "vrijwilligers",
};

export default [
  {
    path: WeldoenersPaths.Approve,
    loadComponent: () =>
      import("./pages/approve-jobs/approve-jobs.component").then((c) => c.ApproveJobsComponent),
    data: {
      breadcrumb: "Vacatures goedkeuren",
      title: "Vacatures goedkeuren",
      subscriptionTypes: [1],
    },
  },
  {
    path: WeldoenersPaths.Statistics,
    loadComponent: () =>
      import("./pages/weldoeners-statistics/weldoeners-statistics.component").then(
        (c) => c.WeldoenersStatisticsComponent
      ),
    data: {
      breadcrumb: "Overzicht Wéldoeners",
      title: "Overzicht Wéldoeners",
      subscriptionTypes: [1],
    },
  },
  {
    path: WeldoenersPaths.Vacatures,
    loadComponent: () =>
      import("./pages/approved-job-list/approved-job-list.component").then(
        (c) => c.ApprovedJobListComponent
      ),
    data: {
      breadcrumb: "Overzicht vacatures",
      title: "Overzicht vacatures",
      platform: Platform.WELDOENERS,
      subscriptionTypes: [1],
    },
  },
  {
    path: WeldoenersPaths.Volunteers,
    loadComponent: () =>
      import("./pages/weldoener-list/weldoener-list.component").then(
        (c) => c.WeldoenerListComponent
      ),
    data: {
      breadcrumb: "Overzicht Wéldoeners",
      title: "Overzicht Wéldoeners",
      platform: Platform.WELDOENERS,
      subscriptionTypes: [1],
    },
  },
] satisfies Route[];
